const errors = {
  INVALID_PHONE: 'Please enter a valid US phone number.',
  UPDATED_INVALID_PHONE: 'Enter a valid number',
  INVALID_PHONE_SMS:
    'Please enter a valid US phone number that can receive SMS messages.',
  INVALID_EMAIL: 'Please enter a valid email address.'
};

export default errors;
